import { render } from "./CadastroDuvidasFrequentesView.vue?vue&type=template&id=4b752688"
import script from "./CadastroDuvidasFrequentesView.vue?vue&type=script&lang=js"
export * from "./CadastroDuvidasFrequentesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__